import DynamicArticleFeed from '../scripts/sections/DynamicArticleFeed';
import DynamicCardFeed from '../scripts/sections/DynamicCardFeed';
import DynamicMediaWithProducts from '../scripts/sections/DynamicMediaWithProducts';
import DynamicMediaWithText from '../scripts/sections/DynamicMediaWithText';
import DynamicProductFeed from '../scripts/sections/DynamicProductFeed';
import DynamicProductSlider from '../scripts/sections/DynamicProductSlider';
import DynamicTestimonials from '../scripts/sections/DynamicTestimonials';
import DynamicTestimonialsSimple from '../scripts/sections/DynamicTestimonialsSimple';

// Sections
import MainCart from '../scripts/sections/MainCart';
import MainCollection from '../scripts/sections/MainCollection';
import MainHeader from '../scripts/sections/MainHeader';
import MainMinicart from '../scripts/sections/MainMinicart';
import MainProduct from '../scripts/sections/MainProduct';
import Sections from '../scripts/helpers/SectionManager';

import initAOS from '../scripts/global/initAos';
import initModals from '../scripts/global/initModals';
import initVideos from '../scripts/global/initVideos';

// Init global sections
const sections = new Sections();
sections.register('main-product', section => new MainProduct(section));
sections.register(
  'main-collection-grid',
  section => new MainCollection(section),
);
sections.register('main-header', section => new MainHeader(section));
sections.register('main-minicart', section => new MainMinicart(section));
sections.register('main-cart', section => new MainCart(section));
sections.register('main-search', section => new MainCollection(section));

sections.register(
  'dynamic-card-feed',
  section => new DynamicCardFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-product-feed',
  section => new DynamicProductFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-media-w-text',
  section => new DynamicMediaWithText(section),
  {
    lazy: true,
  },
);
sections.register(
  'dynamic-testimonials',
  section => new DynamicTestimonials(section),
  {
    lazy: true,
  },
);
sections.register(
  'dynamic-product-slider',
  section => new DynamicProductSlider(section),
  {
    lazy: true,
  },
);
sections.register(
  'dynamic-media-w-products',
  section => new DynamicMediaWithProducts(section),
  {
    lazy: true,
  },
);
sections.register(
  'dynamic-testimonials-simple',
  section => new DynamicTestimonialsSimple(section),
  {
    lazy: true,
  },
);
sections.register(
  'dynamic-article-feed',
  section => new DynamicArticleFeed(section),
  {
    lazy: true,
  },
);

initAOS();
initVideos();
initModals();
